import { StateCreator } from 'zustand';
import { BannerSlice, BannerSliceState } from './index.type';

const initialState: BannerSliceState = {
  showConnectionBanner: false,
  toleranceTimeSurpassed: false,
};

export const createBannerSlice: StateCreator<BannerSlice> = (set, get) => ({
  ...initialState,
  setShowConnectionBanner(showConnectionBanner) {
    set((state) => ({
      ...state,
      showConnectionBanner,
    }));
  },
  setToleranceTimeSurpassed(toleranceTimeSurpassed) {
    set((state) => ({
      ...state,
      toleranceTimeSurpassed,
    }));
  },
  resetBanner: () => set((state) => ({ ...state, ...initialState })),
});
